import { useAppAuth } from "@/auth/use-app-auth";

import { Apex25AccountMenu } from "./demo/Apex25AccountMenu";
import type { HeaderAuthProps } from "./header-auth-slot";

/**
 * The header's sign-in area where Clerk runs (recruit.theresume.io, staging, localhost): the
 * account menu once signed in, else the "Log in / Sign up" links. Plugged into the header through
 * HeaderAuthSlot by main.tsx, so the tryapex25.com bundle never imports Clerk.
 */
export const Apex25HeaderAuth = ({ signedOut }: HeaderAuthProps) => {
  const { isLoading, isAuthenticated } = useAppAuth();

  // Keep the space while Clerk loads, so the header doesn't jump.
  if (isLoading) return <span className="auth-pending">{signedOut}</span>;
  if (isAuthenticated) return <Apex25AccountMenu />;
  return <>{signedOut}</>;
};
